import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Metrics from 'services/metrics';
import { converter } from 'helpers/converter';
import WithApa from 'newComponents/WithApa/WithApa';
import Typography from 'newComponents/Typography';

import Button from 'newComponents/Button';
import Device from './Device';
import './DeviceList.scss';

const devicesToShowCheckbox = 3;

const DeviceList = ({
  devices,
  title,
  translations,
  modifyDevice,
  detachDevice,
  detachDevices,
  showModal,
  closeModal,
  showDevTools,
}) => {
  const [selectedDev, setSelectedIds] = useState([]);
  const handleSelected = selectedId => {
    setSelectedIds(
      selectedDev.includes(selectedId)
        ? selectedDev.filter(i => i.device_id !== selectedId.device_id)
        : [...selectedDev, selectedId],
    );
  };
  const onDeleteSelection = deleteAll => {
    let messageOnDelete = converter.convertApa(
      translations,
      'profile_my_devices_modal_message_detach',
    );
    messageOnDelete = deleteAll
      ? messageOnDelete.replace('{device}', 'todos los dispositivos ')
      : messageOnDelete.replace('{device}', 'los dispositivos seleccionados ');

    const devicesToDelete = deleteAll ? devices : selectedDev;
    const onConfirmDetach = () => {
      detachDevices(devicesToDelete);
      closeModal('ConfirmSimple');
    };

    const modal = {
      modalType: 'ConfirmSimple',
      props: {
        title: converter.convertApa(
          translations,
          'profile_my_devices_modal_title_detach',
        ),
        message: messageOnDelete,
        rightButtonTitle: converter.convertApa(
          translations,
          'profile_my_devices_modal_accept_detach',
        ),
        leftButtonTitle: converter.convertApa(
          translations,
          'profile_my_devices_modal_cancel_detach',
        ),
        onRightButtonClick: onConfirmDetach.bind(this),
      },
    };
    showModal(modal);
  };
  const handleDelete = device => {
    Metrics.newEvent({
      eventCategory: 'Dispositivos',
      eventAction: device.device_category,
      eventLabel: 'Eliminar',
    });
    let messageOnDelete = converter.convertApa(
      translations,
      'profile_my_devices_modal_message_detach',
    );
    messageOnDelete = messageOnDelete.replace(
      '{device}',
      `'${device.device_name}' `,
    );

    const onConfirmDetach = index => {
      Metrics.newEvent({
        eventCategory: 'Dispositivos',
        eventAction: device.device_category,
        eventLabel: 'Eliminar - Aceptar',
      });
      detachDevice(index);
      closeModal('ConfirmSimple');
    };

    const modal = {
      modalType: 'ConfirmSimple',
      props: {
        title: converter.convertApa(
          translations,
          'profile_my_devices_modal_title_detach',
        ),
        message: messageOnDelete,
        rightButtonTitle: converter.convertApa(
          translations,
          'profile_my_devices_modal_accept_detach',
        ),
        leftButtonTitle: converter.convertApa(
          translations,
          'profile_my_devices_modal_cancel_detach',
        ),
        onRightButtonClick: onConfirmDetach.bind(this, device),
        onLeftButtonClick: () => {
          Metrics.newEvent({
            eventCategory: 'Dispositivos',
            eventAction: device.device_category,
            eventLabel: 'Eliminar - Cancelar',
          });
        },
      },
    };
    showModal(modal);
  };
  const showDetachAll = devices.length >= devicesToShowCheckbox;
  const renderDevice = device => (
    <li className="listElement">
      <Device
        key={device.device_id}
        device={device}
        onSubmit={modifyDevice}
        onDelete={handleDelete}
        onSelect={handleSelected}
        selected={selectedDev.includes(device.device_id)}
        showCheckbox={showDetachAll}
      />
    </li>
  );
  return (
    <>
      <div className="Title">{title}</div>
      {devices.length === 0 && (
        <div
          className="padding-2 text-center  box-dispositivos-vacio"
          id="paneDispositivoErrorMsg"
        >
          <div className="panel panel-gray-light padding-2 full-width">
            <i className="fa fa-info-circle texto-blanco fa-3x text-center" />
            <Typography element="p">
              {converter.convertApa(
                translations,
                'profile_my_devices_no_attach',
              )}
            </Typography>
          </div>
        </div>
      )}
      <ul className="deviceList">{devices.map(renderDevice)}</ul>
      {/* {showDetachAll && (
        <Button
          size="full"
          classes={['detachButton']}
          disabled={selectedDev.length < 1}
          onClick={() => {
            onDeleteSelection();
          }}
        >
          Desvincular seleccionados
        </Button>
      )} */}
      {showDevTools && showDetachAll && (
        <Button
          size="full"
          classes={['detachButton']}
          onClick={() => {
            onDeleteSelection(true);
          }}
        >
          Desvincular todos los dispositivos
        </Button>
      )}
      {showDevTools && showDetachAll && (
        <Button
          size="full"
          classes={['detachButton']}
          onClick={() => {
            onDeleteSelection(true);
          }}
        >
          Desvincular todos los dispositivos
        </Button>
      )}
    </>
  );
};

DeviceList.propTypes = {
  devices: PropTypes.array.isRequired,
  modifyDevice: PropTypes.func,
  detachDevice: PropTypes.func,
  detachDevices: PropTypes.func,
  translations: PropTypes.object,
  showDevTools: PropTypes.bool,
};

export default WithApa(DeviceList);
